import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import { BaseFontColors } from "../constants";
import { formatPenetrationPercentage } from "../../../pages/Workspace/utils";

export const createXAxis = (chart: am4charts.XYChart) => {
  const xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  xAxis.dataFields.category = "category";
  xAxis.renderer.cellStartLocation = 0.1;
  xAxis.renderer.cellEndLocation = 0.9;
  xAxis.renderer.grid.template.location = 0;
  xAxis.renderer.labels.template.fontSize = 11;
  xAxis.renderer.labels.template.fill = am4core.color(BaseFontColors.TextDark);
  xAxis.renderer.minGridDistance = 1;
  xAxis.renderer.grid.template.disabled = true;

  xAxis.renderer.labels.template.maxWidth = 80;
  xAxis.renderer.labels.template.truncate = true;
  xAxis.renderer.labels.template.tooltipText =
    "{category}[/]\n Total Companies: {totalCompanyCount}";
  return xAxis;
};

export const createYAxis = (
  chart: am4charts.XYChart,
  showPercentageSymbol?: boolean,
  yAxisLabel?: string
) => {
  const yAxis = chart.yAxes.push(new am4charts.ValueAxis());
  yAxis.title.text = yAxisLabel || "";
  yAxis.min = 0;
  yAxis.renderer.labels.template.fontSize = 11;
  yAxis.renderer.labels.template.fill = am4core.color(BaseFontColors.TextDark);

  yAxis.renderer.grid.template.adapter.add("strokeDasharray", () => {
    return "3,3";
  });

  if (showPercentageSymbol) {
    yAxis.numberFormatter = new am4core.NumberFormatter();
    yAxis.numberFormatter.numberFormat = "#.#";

    yAxis.adapter.add("getTooltipText", (text) => `${text}%`);

    yAxis.renderer.labels.template.adapter.add("text", (text) => {
      return `${text}%`;
    });
  }
  if (yAxis.tooltip) {
    yAxis.tooltip.disabled = true;
  }
};

export const createLegends = (chart: am4charts.XYChart) => {
  chart.legend = new am4charts.Legend();
  chart.legend.position = "bottom";
  chart.legend.align = "right";
  chart.legend.contentAlign = "right";
  chart.legend.markers.template.width = 16;
  chart.legend.markers.template.height = 4;
  chart.legend.markers.template.children.clear();
  chart.legend.minHeight = 80;
  chart.legend.maxHeight = 80;
  chart.legend.scrollable = true;
  const rectMarker = chart.legend.markers.template.createChild(
    am4core.RoundedRectangle
  );
  rectMarker.width = 16;
  rectMarker.height = 4;
  rectMarker.adapter.add("fill", (fill, target) => {
    const series =
      target.dataItem && (target.dataItem.dataContext as am4charts.LineSeries);
    if (series && series.stroke) {
      return series.stroke;
    }
    return fill;
  });

  chart.legend.dx = 75;
};

export const tooltipTextProducer = (
  series: am4charts.ColumnSeries,
  name: string
) => {
  series.tooltipText = `Product Name: {name}
  Penetration: {valueY}%
  # of companies: {${name}_count}`;

  // Add adapter to format the penetration value
  series.adapter.add("tooltipText", (text, target) => {
    const value = target.tooltipDataItem?.values.valueY.value || 0;
    const formattedValue =
      value < 1 ? "<1" : formatPenetrationPercentage(value);

    return (text ?? "").replace("{valueY}%", `${formattedValue}%`);
  });
};
